import { LOCALE_DE, LOCALE_EN } from '../locales'

const URLS = {
    [LOCALE_DE]: 'https://support.trendmanager.com/',
    [LOCALE_EN]: 'https://support.trendmanager.com/en/homepage/'
}

export default URLS
